<template>
    <console-content max-width="1440">
        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start"> 배송상품 주문목록 </v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch"> <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터 </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.createdAt[0]" type="date" clearable label="주문일자" placeholder=" " outlined dense hide-details></v-date-field>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-date-field v-model="filter.createdAt[1]" type="date" clearable label="주문일자" placeholder=" " outlined dense hide-details></v-date-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" class="mt-4">
                        <!-- <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.platform" :items="platforms" item-text="text" item-value="value" label="제공업체" placeholder=" " hide-details />
                        </v-col> -->
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.status" :items="statuses" item-text="text" item-value="value" label="주문상태" placeholder=" " outlined dense hide-details />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" placeholder=" " outlined dense hide-details @input="filter.searchValue = null" />
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field
                                v-model="filter.searchValue"
                                label="검색어"
                                placeholder=" "
                                outlined
                                dense
                                hide-details
                                :disabled="!filter.searchKey"
                                @keydown.enter="
                                    page = 1;
                                    search(true);
                                "
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        rounded
                        text
                        @click="
                            page = 1;
                            search(true);
                        "
                    >
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0"></v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" v-bind="{ loading }" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon
                    >엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :items="items" :headers="purchasesHeaders" item-class="temp.rowClass" hide-default-footer disable-sort class="mt-3 mx-1 elevation-1">
            <template #[`item.no`]="{ item }">
                {{ (page - 1) * limit + items.indexOf(item) + 1 }}
            </template>
            <template #[`item.orderNo`]="{ item }">
                <div>{{ item.order.orderNo }}</div>
                <div>{{ item.purchaseNo }}</div>
            </template>
            <template #[`item.product`]="{ item }">
                <v-row align="center">
                    <v-col md="auto" class="py-0">
                        <v-img v-if="item.curProduct.thumb" :src="item.curProduct.thumb" contain max-width="96" max-height="96"></v-img>
                        <v-responsive v-else width="96" height="96">
                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                <v-icon>mdi-image</v-icon>
                            </v-row>
                        </v-responsive>
                    </v-col>
                    <v-col>
                        <div>{{ item.product.name }}</div>
                        <template v-if="item.product.optionalNames.length">
                            <div v-for="(val, index) in item.product.optionalNames" :key="index">
                                {{ `${val} : ${item.product.optionalValues[index]}` }}
                            </div>
                        </template>
                        <div></div>
                    </v-col>
                </v-row>
            </template>
            <template #[`item.buyer`]="{ item }">
                <div>{{ item.order.buyer.name }} [{{ item.order.buyer.username }}]</div>
                <div>{{ item.order.buyer.phone.phoneNumberFormat() }}</div>
            </template>
            <template #[`item.receiver`]="{ item }">
                <div>{{ item.order.receiver.name }}</div>
                <div>{{ item.order.receiver.phone.phoneNumberFormat() }}</div>
            </template>
            <template #[`item.product.isTaxFree`]="{ item }">
                {{ item.product.isTaxFree ? "면세" : "과세" }}
            </template>
            <template #[`item.order.cashbill.status`]="{ item }">
                {{ item.isCashbill ? "신청" : "미신청" }}
            </template>
            <template #[`item.quantity`]="{ item }">
                <span>{{ item?.quantity?.format?.() }}개</span>
            </template>
            <template #[`item.supplyAmount`]="{ item }">
                <span>{{ ((item.product.supplyPrice || 0) * item.quantity)?.format?.() }}원</span>
            </template>
            <template #[`item.totalAmount`]="{ item }">
                <span v-if="item.saleAmount">{{ item?.saleAmount?.format?.() }}원</span>
            </template>
            <template #[`item.createdAt`]="{ item }">
                {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
            <template #[`item.actions`]="{ item }">
                <v-icon small @click="edit(item)">mdi-pencil</v-icon>
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)" />
    </console-content>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel } from "@mdi/js";

import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

export default {
    components: {
        ConsoleContent,
        VDateField,
    },
    data() {
        return {
            mdiMicrosoftExcel,
            loading: false,

            showSearch: true,

            filter: {
                status: this.$route.query.status || null,
                createdAt: [this.$route.query.createdAt?.[0] || null, this.$route?.query.createdAt?.[1] || null],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "구매자 이름", value: "name" },
                { text: "구매자 아이디", value: "username" },
                { text: "구매자 연락처", value: "phone" },
            ],

            statuses: [
                { text: ":: 전체 ::", value: null },
                { text: "주문완료", value: "주문완료" },
                { text: "결제완료", value: "결제완료" },
                { text: "취소요청", value: "취소요청" },
                { text: "취소불가", value: "취소불가" },
                { text: "취소완료", value: "취소완료" },
                { text: "부분취소완료", value: "부분취소완료" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            purchases: [],
            purchasesHeaders: [
                { text: "no", value: "no", align: "center" },
                { text: "주문번호\n상품주문번호", value: "orderNo", align: "left", class: "white-space-pre-line" },
                { text: "상품", value: "product", align: "center" },
                { text: "수량", value: "quantity", align: "center" },
                { text: "공급가", value: "supplyAmount", align: "center" },
                { text: "판매가", value: "totalAmount", align: "center" },
                { text: "구매자", value: "buyer", align: "center" },
                { text: "수취인", value: "receiver", align: "center" },
                { text: "면세여부", value: "product.isTaxFree", align: "center" },
                { text: "현금영수증", value: "order.cashbill.status", align: "center" },
                { text: "구매 일시", value: "createdAt", align: "center" },
                { text: "상태", value: "status", align: "center" },
                { text: "actions", value: "actions", align: "center" },
            ],
        };
    },
    computed: {
        isMobile() {
            return this.$route.query.mode === "mobile";
        },
        items() {
            const colors = ["table-row-grey", null];

            return [...this.purchases].reduce((items, item) => {
                let prev = items.at(-1);
                let isPrevSameOrder = prev?._order === item._order;

                let rowClass = prev?.temp?.rowClass;

                if (!isPrevSameOrder) {
                    let prevColorIndex = colors.indexOf(prev?.temp?.rowClass || null);
                    rowClass = colors[(prevColorIndex + 1) % 2];
                }

                items.push({ ...item, temp: { rowClass } });
                return items;
            }, []);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search(routable = false) {
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            let { summary, purchases } = await api.console.shop.delivery.purchases.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });
            
            this.purchases = purchases.map((purchase) => ({...purchase, isCashbill: purchase?.order?.cashbill?.status ? true : false }));
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        edit(purchase) {
            this.$router.push(`/console/shop/delivery/orders/${purchase._order}`);
        },

        async excel() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let { purchases } = await api.console.shop.delivery.purchases.gets({
                    headers: {
                        limit: 0,
                    },
                    params: this.filter,
                });

                var rows = [];
                purchases.forEach((purchase) => {
                    rows.push({
                        주문번호: purchase?.order.orderNo,
                        결제번호: purchase?.purchaseNo,
                        상품명: this.setOrderNameWithOptions(purchase),
                        수량: purchase.quantity,
                        공급가: (purchase.product.supplyPrice || 0) * purchase.quantity,
                        결제금액: purchase.saleAmount,
                        과세여부: purchase.product.isTaxFree ? "면세" : "과세",
                        현금영수증: purchase?.order?.cashbill?.status ? "신청" : "미신청",
                        "구매자 이름": purchase.order.buyer.name,
                        "구매자 아이디": purchase.order.buyer.username,
                        "구매자 연락처": purchase.order.buyer.phone,
                        "수취인 이름": purchase.order.buyer.name,
                        "수취인 연락처": purchase.order.buyer.phone,
                        구매일: purchase.createdAt ? this.$dayjs(purchase.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-",
                        상태: purchase.status,
                    });
                });

                var workbook = new XLSX.utils.book_new();
                var worksheet = XLSX.utils.json_to_sheet(rows);

                XLSX.utils.book_append_sheet(workbook, worksheet, "new");
                XLSX.writeFile(workbook, `배송상품_주문목록_${this.$dayjs().format("YYYYMMDD_HHmmss")}.xlsx`);
                this.loading = false;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
        setOrderNameWithOptions(purchase) {
            const { product } = purchase;
            if (!product?.optionalNames.length) return purchase.product.name;
            let name = purchase.product.name;
            name += "(";
            for (const [index, option] of product.optionalNames.entries()) {
                name += `${option}: `;
                name += product.optionalValues[index];
                if (index !== product.optionalNames.length - 1) {
                    name += "/";
                }
            }
            name += ")";

            return name;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .white-space-pre-line {
        white-space: pre-line;
    }

    tr.table-row-grey {
        background-color: rgba(68, 81, 99, 0.06);
    }
}
</style>
